module.exports = __webpack_public_path__ + "img/logo.eca27b9a.png";